import styled from "styled-components";
import * as Colors from "../colors";

// tslint:disable-next-line
export const ManagerSearchOptionsContainer = styled.div`
  background-color: ${Colors.searchBackground};
  padding: 20px 20px;
  border-bottom: 1px solid ${Colors.searchFilterBorderColor};
`;
